import FormulateCssClassService from '@/Services/FormulateCssClassService/FormulateCssClassService';

class ElementCssClassService extends FormulateCssClassService {
    public process(): void {
        if (this.isBox()) {
            this.addNonGroupedClass([
                'px-2',
            ])
        }

        if (this.isSlider()) {
            this.addClass('flex items-center')
        }
    }
}

export default ElementCssClassService
